import React from 'react';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import UploadCard from './UploadCard';

interface QuickUploadCardProps {
  uploading: boolean;
  onSelectIncidentFiles: () => void;
}

const QuickUploadCard: React.FC<QuickUploadCardProps> = ({ uploading, onSelectIncidentFiles }) => {
  const { t } = useTranslation();

  return (
    <UploadCard title={t('testUpload.quickUpload')}>
      <Button onClick={onSelectIncidentFiles} disabled={uploading}>
        <Upload strokeWidth={1.9} />
        <span className="revy-cjk">{t('testUpload.selectIncidentFiles')}</span>
      </Button>
      <p className="revy-cjk mt-2 text-xs leading-[1.6] text-muted-foreground">
        {t('testUpload.quickUploadHelp')}
      </p>
    </UploadCard>
  );
};

export default QuickUploadCard;
